// Version : 0.0.1
// Author : VISHNU
// LastEdit : KARTHEESWARAN
// MODFIED DATE:31-07-2025
import { docodeHexResponse } from '../../_common/common.utils';
import insuranceCompanyActionTypes from './insurance-company.types';

const INITIAL_STATE = {
	addInsuranceCompanyDetailsResponse: null,
	updateInsuranceCompanyDetailsResponse: null,

	getInsuranceCompanyListResponse: null,
	getInsuranceCompanyListArr: [],

	fetchInsuranceCompanyDetailsResponse: null,
	fetchInsuranceCompanyDetailsArr: [],

	deleteInsuranceCompanyDetailsResponse: null,

	fetchAllInsuranceCompanysResponse: null,
	fetchAllInsuranceCompanysArr: [],
};

const insuranceCompanyReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  START ADD INSURANCE COMPANY DETAILS  ******************** */
		case insuranceCompanyActionTypes.ADD_INSURANCE_COMPANY_DETAILS_SUCCESS:
			return { ...state, addInsuranceCompanyDetailsResponse: action.payload };

		case insuranceCompanyActionTypes.ADD_INSURANCE_COMPANY_DETAILS_FAILURE:
			return { ...state, addInsuranceCompanyDetailsResponse: action.payload };

		case insuranceCompanyActionTypes.ADD_INSURANCE_COMPANY_DETAILS_RESPONSE_CHANGED:
			return { ...state, addInsuranceCompanyDetailsResponse: null };
		/** *********************  END ADD INSURANCE COMPANY DETAILS  ******************** */

		/*************** START UPDATE INSURANCE COMPANY DETAILS ******************/
		case insuranceCompanyActionTypes.UPDATE_INSURANCE_COMPANY_DETAILS_SUCCESS:
			return { ...state, updateInsuranceCompanyDetailsResponse: action.payload };

		case insuranceCompanyActionTypes.UPDATE_INSURANCE_COMPANY_DETAILS_FAILURE:
			return { ...state, updateInsuranceCompanyDetailsResponse: action.payload };

		case insuranceCompanyActionTypes.UPDATE_INSURANCE_COMPANY_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateInsuranceCompanyDetailsResponse: null };
		/*************** END UPDATE INSURANCE COMPANY DETAILS ******************/

		/*************** START GET INSURANCE COMPANY LIST ******************/
		case insuranceCompanyActionTypes.GET_INSURANCE_COMPANY_LIST_SUCCESS:
			return {
				...state,
				getInsuranceCompanyListResponse: action.payload,
				getInsuranceCompanyListArr: docodeHexResponse(
					action.payload,
					'GetInsuranceCompanyListKey',
				),
			};

		case insuranceCompanyActionTypes.GET_INSURANCE_COMPANY_LIST_FAILURE:
			return {
				...state,
				getInsuranceCompanyListResponse: action.payload,
				getInsuranceCompanyListArr: [],
			};

		case insuranceCompanyActionTypes.GET_INSURANCE_COMPANY_LIST_RESPONSE_CHANGED:
			return { ...state, getInsuranceCompanyListResponse: null };
		/*************** END GET INSURANCE COMPANY LIST ******************/

		/*************** START FETCH INSURANCE COMPANY DETAILS ******************/
		case insuranceCompanyActionTypes.FETCH_INSURANCE_COMPANY_DETAILS_SUCCESS:
			return {
				...state,
				fetchInsuranceCompanyDetailsResponse: action.payload,
				fetchInsuranceCompanyDetailsArr: docodeHexResponse(
					action.payload,
					'FetchInsuranceCompanyDetailsKey',
				),
			};

		case insuranceCompanyActionTypes.FETCH_INSURANCE_COMPANY_DETAILS_FAILURE:
			return { ...state, fetchInsuranceCompanyDetailsResponse: action.payload };

		case insuranceCompanyActionTypes.FETCH_INSURANCE_COMPANY_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				fetchInsuranceCompanyDetailsResponse: null,
			};
		/*************** END FETCH INSURANCE COMPANY DETAILS ******************/

		/*************** START DELETE INSURANCE COMPANY DETAILS ******************/
		case insuranceCompanyActionTypes.DELETE_INSURANCE_COMPANY_DETAILS_SUCCESS:
			return { ...state, deleteInsuranceCompanyDetailsResponse: action.payload };

		case insuranceCompanyActionTypes.DELETE_INSURANCE_COMPANY_DETAILS_FAILURE:
			return { ...state, deleteInsuranceCompanyDetailsResponse: action.payload };

		case insuranceCompanyActionTypes.DELETE_INSURANCE_COMPANY_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteInsuranceCompanyDetailsResponse: null };
		/*************** START DELETE INSURANCE COMPANY DETAILS ******************/

		/*************** START FETCH ALL INSURANCE COMPANYS ******************/
		case insuranceCompanyActionTypes.FETCH_ALL_INSURANCE_COMPANY_SUCCESS:
			return {
				...state,
				fetchAllInsuranceCompanysResponse: action.payload,
				fetchAllInsuranceCompanysArr: docodeHexResponse(action.payload, 'GetBranchListKey'),
			};

		case insuranceCompanyActionTypes.FETCH_ALL_INSURANCE_COMPANY_FAILURE:
			return { ...state, fetchAllInsuranceCompanysResponse: action.payload };

		case insuranceCompanyActionTypes.FETCH_ALL_INSURANCE_COMPANY_RESPONSE_CHANGED:
			return { ...state, fetchAllInsuranceCompanysResponse: null };

		/*************** START FETCH ALL INSURANCE COMPANYS ******************/

		default:
			return state;
	}
};

export default insuranceCompanyReducer;
